import AdvertCard from 'components/common/advert-card';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { useGetApiV1ClientAdsQuery } from 'service/api/allApis';
import { Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react';

const VipAdverts = () => {
    const { t } = useTranslation();
    const { data, isLoading, isFetching } = useGetApiV1ClientAdsQuery({
        isPaginated: false,
        pageSize: 20,
        isVip: true,
    });
    const loading = isFetching || isLoading;

    if (data && data.items?.length === 0) return null;

    return (
        <div className="mt-10 md:mt-0 mb-6 md:mb-10 lg:mb-20 w-full px-5 md:px-0 md:w-[925px] lg:w-[1240px] mx-auto">
            <h2 className="text-brend text-center text-[32px] leading-[44px] font-bold tracking-[3.84px] mb-6">
                {t('general.vip-adverts')}
            </h2>
            <Swiper
                loop
                freeMode
                navigation
                pagination={{
                    clickable: true,
                }}
                autoplay={{
                    delay: 2000,
                    pauseOnMouseEnter: true,
                }}
                slidesPerView={'auto'}
                className="w-full md:h-[500px] mx-auto lg:h-[520px] mt-0 md:mt-10 py-6 md:py-10 select-none"
                modules={[Navigation]}
            >
                {loading &&
                    [...Array(6)].map((_, index) => (
                        <SwiperSlide
                            key={index}
                            style={{}}
                            className="w-[180px] sm:w-[240px] md:w-[320px] mx-2"
                        >
                            <AdvertCard.Skeleton key={index} />
                        </SwiperSlide>
                    ))}
                {data?.items?.map((advert) => (
                    <SwiperSlide
                        key={advert.id}
                        style={{}}
                        onClick={() => window.scrollTo(0, 0)}
                        className="w-[180px] sm:w-[240px] md:w-[320px] mr-2 md:mr-4"
                    >
                        <AdvertCard key={advert.id} advert={advert} />
                    </SwiperSlide>
                ))}
            </Swiper>
            <Link
                to="/adverts?isVip=true"
                className="block text-center text-[16px] text-brend mt-2 cursor-pointer font-semibold hover:underline"
            >
                {t('general.more-vip-advert')}
            </Link>
        </div>
    );
};

export default VipAdverts;
